"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
exports.PrivacyIcon = function (_a) {
    var isPrivate = _a.isPrivate, onTogglePrivacy = _a.onTogglePrivacy;
    return (React.createElement("a", { href: '#', onClick: handleTogglePrivacy, title: isPrivate ? 'Make public' : 'Make private' },
        React.createElement("svg", { width: '24', height: '24', fill: 'none', stroke: '#c2c2c2', strokeWidth: '2' },
            React.createElement("path", { d: 'M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z' }),
            React.createElement("circle", { cx: '12', cy: '12', r: '3' }),
            isPrivate ? React.createElement("line", { x1: '0', y1: '24', x2: '24', y2: '0' }) : null)));
    function handleTogglePrivacy(evt) {
        evt.preventDefault();
        if (onTogglePrivacy) {
            onTogglePrivacy(!isPrivate);
        }
    }
};
exports.PrivacyIcon.displayName = 'PrivacyIcon';
